import { render, staticRenderFns } from "./MshipsversionTemplateForm.vue?vue&type=template&id=14b1a4b1"
import script from "./MshipsversionTemplateForm.vue?vue&type=script&lang=js"
export * from "./MshipsversionTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports